/**
 * 400 에러 메시지 추출 함수
 * @param responseData - 서버 응답 데이터
 * @returns 표시할 에러 메시지
 */
export const getBadRequestMessage = (responseData) => {
    // validation 배열이 존재하고 비어있지 않은 경우, 첫 번째 요소의 message 반환
    if (responseData.validation &&
        Array.isArray(responseData.validation) &&
        responseData.validation.length > 0) {
        return responseData.validation[0].message;
    }
    // validation이 없는 경우 detail 반환, 없으면 기본 메시지
    return responseData.detail || '잘못된 요청입니다.';
};
//# sourceMappingURL=error.js.map